module.exports = __webpack_public_path__ + "static/preview-7-4bc0f0a7fcef9f04aed1db84b3f3fbb3.png";